export enum Tabs {
    REQUEST_INFORMATION = 'request-information',
    REFERRALS = 'referrals',
    COMMENTS = 'comments',
    ACTIVITY_LOG = 'activity-log'
}
